import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const withRouter = (WrappedComponent) => {
    const ComponentWithRouter = (props) => {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();

        return (
            <WrappedComponent
                {...props}
                location={location}
                navigate={navigate}
                params={params}
            />
        );
    };

    return ComponentWithRouter;
};

export default withRouter;